(function () {

    angular
        .module('smartertoolsApp')
        .controller('trackSignupProgress', ['$timeout', '$scope', '$routeParams', '$location', '$http', trackSignupProgress]);

    function trackSignupProgress($timeout, $scope, $routeParams, $location, $http) {
        const vm = this;
        vm.guid = $routeParams.guid;
        vm.sitePrefix = $routeParams.sitePrefix;
        vm.step = $location.search().step || 'building';
        vm.timeStarted = new Date();
        vm.elapsedSeconds = 0;

        // Functions
        vm.fullSitePath = fullSitePath;
        vm.updateBuildTimer = updateBuildTimer;
        vm.updateBuildStatus = updateBuildStatus;
        vm.popupLogin = popupLogin;

        activate();

        // -----------------------------------------------

        function activate() {
            vm.updateBuildTimer();
            vm.updateBuildStatus();
        }

        function fullSitePath(prefix) {
            return `https://${prefix}.smartertrack.com/`;
        }

        function popupLogin() {
            ShowLoginOverlay();
            return false;
        }

        function updateBuildTimer() {
            const diff = (new Date()).getTime() - vm.timeStarted.getTime();
            vm.elapsedSeconds = Math.round(Math.abs(diff / 1000));
            $timeout(vm.updateBuildTimer, 1000);
        }

        function updateBuildStatus() {
            if (vm.step !== 'building')
                return;
            $http.post(`${apiRootUrl}v1/hosted-smartertrack/build-progress`, JSON.stringify({ServiceSignupGuid: vm.guid}))
                .then(response => {
                    let data = response.data;
                    vm.step = data.Status || 'building';
                    $scope.$applyAsync();
                }, () => {
                });
        }
    }

})();